import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'reducers/store'

export const selectUserSubscription = (state: Pick<RootState, 'subscription'>) => {
  return state.subscription.user.value
}
export const selectSubGroupUserSubscription = (state: Pick<RootState, 'subscription'>) => {
  return state.subscription.userSubGroup.value
}
export const selectClientUserGroups = createSelector(
  (state: Pick<RootState, 'subscription'>) =>
    state.subscription.clientUserGroups?.value?.user_groups,
  (groups) => (Array.isArray(groups) ? groups : [])
)
export const selectClientInfo = (state: Pick<RootState, 'subscription'>) => {
  const v = state.subscription.clientUserGroups?.value
  return v ? { client_id: v.client_id, client_name: v.client_name } : null
}
